<template>
  <UiBaseIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="icon"
  >
    <path
      d="M5.52536 12.3965C5.23434 12.6905 5.23434 13.164 5.52536 13.4581C5.82067 13.7565 6.30272 13.7565 6.59803 13.4581L11.3038 8.70344C11.6895 8.31377 11.6895 7.68623 11.3038 7.29656L6.59803 2.54191C6.30272 2.24353 5.82067 2.24353 5.52536 2.54191C5.23434 2.83595 5.23434 3.3095 5.52536 3.60355L9.87661 8L5.52536 12.3965Z"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>

<style scoped lang="scss">
  .mirror {
    transform: scaleX(-1);
  }
</style>
